<template>
  <div class="content">
    <h1>Support</h1>
    <p><strong>App Name:</strong> Bantuek</p>
    <p><strong>Contact Email:</strong> chanon.manojit@hotmail.com</p>

    <h2>1. Need Help?</h2>
    <p>
      If you're experiencing issues with the Bantuek app or have questions about your subscription, feel free to contact us directly.
    </p>
    <p>
      📧 <a href="mailto:chanon.manojit@hotmail.com">chanon.manojit@hotmail.com</a>
    </p>

    <h2>2. Common Questions</h2>
    <ul>
      <li><strong>How do I restore my purchase?</strong><br />
        Tap “Restore Purchases” at the bottom of the paywall screen in the app.
      </li>
      <li><strong>How do I cancel my subscription?</strong><br />
        You can cancel your subscription via your Apple ID settings under “Subscriptions”.
      </li>
      <li><strong>I changed my phone. Will my data be saved?</strong><br />
        Yes. Your data is synced to the cloud and linked to your login (Apple ID or Google Account).
      </li>
      <li><strong>Can I delete my account?</strong><br />
        Yes. You can delete your account directly from the app by tapping the "Delete Account" button in the Settings screen.
      </li>
    </ul>

    <h2>3. Useful Links</h2>
    <ul>
      <li><a href="https://chanonmanojit.com/bantuek/privacy-policy" target="_blank">Privacy Policy</a></li>
      <li><a href="https://chanonmanojit.com/bantuek/terms-of-use" target="_blank">Terms of Use</a></li>
    </ul>

    <h2>4. Response Time</h2>
    <p>
      We usually respond within 24–48 hours. Thank you for your patience.
    </p>
  </div>
</template>
<script>
export default {
  name: 'Support'
}
</script>

<style lang="scss" scoped>
.content {
    // padding: 0rem 5rem;
    animation: moveInBottom .5s ease-out .1s;
    animation-fill-mode: backwards;
    .img {
        margin-top: 1rem;
        width: 50%;
    }
    .img-hor {
        display: flex;
        flex-direction: column;
    }
}
</style>